import { createFileRoute, Outlet } from "@tanstack/react-router"
import CoreLayout from "@/components/coreLayout/CoreLayout"

function CoreRoute() {
  return (
    <CoreLayout>
      <Outlet />
    </CoreLayout>
  )
}

export const Route = createFileRoute("/core")({ component: CoreRoute })
